export default __webpack_public_path__ + "static/media/equipe.dd33fbbf.png";